import { render, staticRenderFns } from "./LogoYaneSvg.vue?vue&type=template&id=01e0c14f&"
import script from "./LogoYaneSvg.vue?vue&type=script&lang=js&"
export * from "./LogoYaneSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports